import { WishlistApp } from "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.19.5/wishlist-app.js";

export const createApp = ({ settings, config, locale }) => {
  if (window.WishlistKing) {
    return;
  }

  const app = new WishlistApp({
    config,
    settings,
    locale,
    dependencies: [
      "https://cdn.jsdelivr.net/npm/@appmate/wishlist@4.19.5/components/wishlist.css",
      "//vins-etonnants.com/cdn/shop/t/37/assets/wishlist-king-custom.css?v=109453460828161003121683297216",
      "//vins-etonnants.com/cdn/shop/t/37/assets/wishlist-king-components.js?v=103593415816185115361683297376",
    ],
  });

  initEvents(app);
  initComponents(app);

  return app;
};

const initComponents = ({ theme, routes }) => {
  // Header link
  theme.watch(
    {
      selector: `#shopify-section-side-cart`,
    },
    (target) => {
      target.insertBefore(
        theme.createComponent("wishlist-link", {
          props: {
            layout: "icon-only",
            alignment: "center",
            badgeLayout: "pill-and-text",
            badgeParentheses: false,
            badgeHiddenIfEmpty: true,
            badgeFloating: {
              position: {
                placement: "bottom-end",
                inset: true,
              },
              offset: {
                mainAxis: 8,
                alignmentAxis: 0,
              },
            },
          },
        })
      );
    }
  );

  // Grid items
  theme.watch(
    {
      selector: `.usf-grid__item-link[href*="/products/"]`,
    },
    (target) => {
      target.insertAfter(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(target.element.href),
            variantId: theme.getVariantId(target.element.href),
          },
          props: {
            layout: "icon-only",
            alignment: "center",
            floating: {
              reference: target,
              position: {
                placement: "top-end",
                inset: true,
              },
              offset: 0,
            },
          },
        })
      );
    }
  );
  
  theme.watch(
    {
      selector: `.card-product > a[href*="/products/"]`,
      pageType: ["home", "product", "collection"],
    },
    (target) => {
      target.insertAfter(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(target.element.href),
            variantId: theme.getVariantId(target.element.href),
          },
          props: {
            layout: "icon-only",
            alignment: "center",
            floating: {
              reference: target,
              position: {
                placement: "top-end",
                inset: true,
              },
              offset: 0,
            },
          },
        })
      );
    }
  );

  // Product page
  theme.watch(
    {
      selector: `#buy-buttons`,
      pageType: ["product"],
    },
    (target) => {
      target.closest("div.flex").insertAfter(
        theme.createComponent("wishlist-button", {
          dataset: {
            productHandle: theme.getProductHandle(document.location.href),
            variantId: theme.getVariantId(document.location.href),
          },
          props: {
            layout: "icon-and-text",
            alignment: "left",
            fullWidth: true,
            outline: false,
          },
        })
      );
    }
  );

  // Wishlist page
  theme.watch(
    {
      selector: "#wishlist-page",
    },
    (target) => {
      target.replace(
        theme.createComponent("wishlist-page", {
          dataset: {
            wishlistId: theme.getWishlistId(window.location.pathname),
          },
        })
      );
    }
  );
};

const initEvents = (app) => {
  app.events.subscribe("wk:wishlist:add-to-cart:success", (event) => {
    // window.location.href = app.routes.cartUrl;
  });
  app.events.subscribe("wk:wishlist:add-all-to-cart:success", (event) => {
    window.location.href = app.routes.cartUrl;
  });
  app.events.subscribe("wk:wishlist:login-required", (event) => {
    const ignoreActions = ["wishlist:private:load"];
    if (!ignoreActions.includes(event.data.action)) {
      window.location.href = app.routes.accountLoginUrl;
    }
  });
};
